// src/components/CombatPay.js
import React from 'react';
import { Shield, HelpCircle } from 'react-feather';

/**
 * A component to ask about and collect the amount of non-taxable combat pay.
 * @param {object} props - The component props.
 * @param {object} props.formData - The main form data object from the App state.
 * @param {function} props.onDataChange - The main handler from App.js to update the state.
 */
function CombatPay({ formData, onDataChange }) {

  // This special handler converts the string value from radio buttons ("true"/"false")
  // into a real boolean before passing it to the main state updater.
  const handleRadioChange = (e) => {
    const booleanValue = e.target.value === 'true';
    const syntheticEvent = {
      target: {
        name: e.target.name,
        value: booleanValue,
        type: 'radio'
      }
    };
    onDataChange(syntheticEvent);
  };

  return (
    <div className="form-section" style={{ marginTop: '2rem' }}>
      <div className="content-box-header">
        <div className="header-title-with-help">
          <h2><Shield size={20} className="icon-orange" /> Non-Taxable Combat Pay</h2>
        </div>
      </div>

      <div className="dependent-card">
        <div className="form-group">
          <div className="header-title-with-help" style={{ marginBottom: '0.5rem' }}>
            <label>Did you receive any non-taxable combat pay?</label>
            <div className="has-tooltip header-help-icon" data-tooltip="While this pay is not taxed, you can elect to include it in your 'earned income' for the purpose of calculating certain credits, like the Earned Income Tax Credit (EITC).">
              <HelpCircle size={16} />
            </div>
          </div>
          <div className="radio-group">
            <input type="radio" id="combatPayNo" name="receivedCombatPay" value="false" checked={formData.receivedCombatPay === false} onChange={handleRadioChange} />
            <label htmlFor="combatPayNo">No</label>
            <input type="radio" id="combatPayYes" name="receivedCombatPay" value="true" checked={formData.receivedCombatPay === true} onChange={handleRadioChange} />
            <label htmlFor="combatPayYes">Yes</label>
          </div>
        </div>

        {/* Conditionally rendered amount input */}
        {formData.receivedCombatPay && (
          <div className="form-group" style={{ marginTop: '1rem' }}>
            <label>Amount of Non-Taxable Combat Pay</label>
            <input
              type="number"
              name="nonTaxableCombatPayAmount"
              value={formData.nonTaxableCombatPayAmount ?? ''}
              onChange={onDataChange}
              placeholder="0"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default CombatPay;
